import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AuthenticationService } from '../../core/services';
import { BaseApiService } from './api';
import { RodDto } from '../dto';

@Injectable({
    providedIn: 'root'
})
export class RoDs {
    public rodRowData = [];

    readonly rodData$: Observable<Array<RodDto>>;
    readonly rodDataRefresh$: Observable<void>;

    private rodRefreshSubject: Subject<void> = new Subject();
    private rodSubject = new BehaviorSubject([]);
    private readonly url: string = 'service/contactcloud/research';

    constructor(
        private auth: AuthenticationService,
        private readonly baseApiService: BaseApiService
    ) {
        this.rodData$ = this.rodSubject.asObservable();
        this.rodDataRefresh$ = this.rodRefreshSubject.asObservable();
    }

    getRods(): Observable<any> {
        return this.baseApiService.get(`${this.url}/requestList`, { showError: true });
    }

    setRoDs(data) {
        this.rodSubject.next(data);
    }

    refreshRod(): void {
        this.rodRefreshSubject.next();
    }

    updateShareResearch(requestBody) {
        return this.baseApiService.post(`${this.url}/shareResearch`, requestBody, { showError: true });
    }

    updateRodDailyDigestEmail(value: boolean): Observable<any> {
        return this.baseApiService.post('account/rodDailyDigestEmail', undefined, { params: { status: String(value) } });
    }

    isRoDHasData(): boolean {
        return !!this.rodSubject.getValue().length;
    }
}
